import React from 'react';
import { cn } from 'lib/utils';

const Skeleton = ({ className, children }: { className?: string; children?: React.ReactNode }) => (
  <div className={cn('animate-pulse bg-gray-200 dark:bg-gray-700 rounded', className)}>
    {children}
  </div>
);

const ChatSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-3 p-4 sm:p-6">
      <Skeleton className="flex w-4/5 rounded-lg text-right">
        <div className="h-20" />
      </Skeleton>
      <div className="flex flex-row justify-end text-right">
        <Skeleton className="flex w-2/5 rounded-lg text-right">
          <div className="h-10" />
        </Skeleton>
      </div>
      <Skeleton className="flex w-full rounded-lg text-right">
        <div className="h-40" />
      </Skeleton>
      <div className="flex flex-row justify-end text-right">
        <Skeleton className="flex w-4/5 rounded-lg text-right">
          <div className="h-10" />
        </Skeleton>
      </div>
      <Skeleton className="hidden w-3/5 rounded-lg text-right md:flex">
        <div className="h-24" />
      </Skeleton>
    </div>
  );
};

export default ChatSkeleton;
